import { Plat } from "../../model/menudesign/Plat";

const apiUrl = process.env.REACT_APP_API_URL;
export const GetPlats = async ( page : string ) => {
    try {
        const response = await fetch(`${apiUrl}:8072/plats`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            }
        });
        const jsonData = await response.json();
        return jsonData.plats as Plat[];
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};